/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StorefrontButtonShape {
  SHARP = 'sharp',
  MEDIUM = 'medium',
  ROUNDED = 'rounded',
}
